var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEuropeanWindowsIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7003_777)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7003_777",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 0H0V36H36V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7003_777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5607 19.9213L30.1807 18.5713L18.5557 30.1813L19.9507 31.5763C21.1207 32.7463 22.3357 33.3313 23.5357 33.3313C24.7357 33.3313 25.9507 32.7463 27.1207 31.5763L31.5607 27.1363C33.9457 24.7363 33.9457 22.3213 31.5607 19.9213Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0356 4.39418C13.6806 2.03918 11.2056 2.03918 8.85063 4.39418L4.39562 8.83418C2.05563 11.1892 2.05563 13.6642 4.39562 16.0193L5.77562 17.3993L17.4006 5.77418L16.0356 4.39418Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7158 5.91013C30.7508 10.8151 26.2658 17.2201 21.9908 21.4051C21.3758 17.5351 18.2858 14.5051 14.3857 13.9651C18.5858 9.67514 25.0358 5.13013 29.9558 3.15013C30.8258 2.82013 31.6958 3.07513 32.2358 3.61513C32.8058 4.18513 33.0758 5.04013 32.7158 5.91013Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6706 22.6364C20.3706 22.8914 20.0706 23.1464 19.7706 23.3864L17.0856 25.5314C17.0856 25.4864 17.0706 25.4264 17.0706 25.3664C16.8606 23.7614 16.1106 22.2764 14.8957 21.0614C13.6657 19.8314 12.1357 19.0814 10.4557 18.8714C10.4107 18.8714 10.3507 18.8564 10.3057 18.8564L12.4807 16.1114C12.6907 15.8414 12.9157 15.5864 13.1557 15.3164L14.1757 15.4514C17.4006 15.9014 19.9956 18.4364 20.5056 21.6464L20.6706 22.6364Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6456 26.4312C15.6456 28.0812 15.0156 29.6562 13.8156 30.8412C12.9006 31.7712 11.6706 32.4012 10.1706 32.5812L6.49562 32.9862C4.48562 33.2112 2.76062 31.4862 2.98562 29.4612L3.39062 25.7712C3.75062 22.4862 6.49562 20.3862 9.40562 20.3262C9.69062 20.3112 10.0056 20.3262 10.3056 20.3562C11.5806 20.5212 12.8106 21.1062 13.8456 22.1262C14.8506 23.1312 15.4206 24.3162 15.5856 25.5612C15.6156 25.8612 15.6456 26.1462 15.6456 26.4312Z",
    fill: "#FECB00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7003_777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuropeanWindowsIcon4);
export default __webpack_public_path__ + "static/media/EuropeanWindowsIcon4.7b1b866ddfb010b447acbb67f21dfc3d.svg";
export { ForwardRef as ReactComponent };